export default [
  {
    path: '/calendars',
    name: 'calendar',
    meta: { requiresAuth: true },
    component: () => import('@/pages/calendar/index.vue')
  }
]
